import { Redirect, Route, Switch } from "react-router-dom";

import AssessmentTemplatePortal from "./components/portals/assessmentTemplatePortal";
import CreatorPortal from "./components/portals/creatorPortal";
import EmpireAdminPortal from "./components/portals/empireOS/empireAdminPortal";
import EmpirePartnerPortal from "./components/portals/empireOS/empirePartnerPortal";
import EmpirePatientPortal from "./components/portals/empireOS/empirePatientPortal";
import EmpireProviderPortal from "./components/portals/empireOS/empireProviderPortal";
import InvitePortal from "./components/portals/invitePortal";
import OnboardingPortal from "./components/portals/onboardingPortal";
import constants from "./assets/constants";

// import NMHAPortal from "./components/portals/nmhaPortal";

const getEmpireOrganizationPortal = awsGroup => {
  if (awsGroup === constants.userGroups.Administrator) {
    return (
      <Switch>
        <Route exact path={constants.appPaths.appPathAdmin}>
          <EmpireAdminPortal />
        </Route>
        <Route exact path={constants.appPaths.appPathAdminInvite}>
          <InvitePortal />
        </Route>
        <Route exact path={constants.appPaths.appPathAdminAssessment}>
          <AssessmentTemplatePortal />
        </Route>
        <Route render={() => <Redirect to={constants.appPaths.appPathAdmin} />} />
      </Switch>
    );
  }

  if (awsGroup === constants.userGroups.Provider) {
    return (
      <Switch>
        <Route exact path={constants.appPaths.appPathProvider}>
          <EmpireProviderPortal />
        </Route>
        <Route render={() => <Redirect to={constants.appPaths.appPathProvider} />} />
      </Switch>
    );
  }

  if (awsGroup === constants.userGroups.Partner) {
    return (
      <Switch>
        <Route exact path={constants.appPaths.appPathPartner}>
          <EmpirePartnerPortal />
        </Route>
        <Route render={() => <Redirect to={constants.appPaths.appPathPartner} />} />
      </Switch>
    );
  }

  if (awsGroup === constants.userGroups.Patient) {
    return (
      <Switch>
        <Route exact path={constants.appPaths.appPathPatient}>
          <EmpirePatientPortal />
        </Route>
        <Route render={() => <Redirect to={constants.appPaths.appPathPatient} />} />
      </Switch>
    );
  }

  //this shouldn't change? Don't even know why this is here
  if (awsGroup === constants.userGroups.Creator) {
    return (
      <Switch>
        <Route exact path={constants.appPaths.appPathCreator}>
          <CreatorPortal />
        </Route>

        <Route exact path={constants.appPaths.appPathCreatorDemoOnboarding}>
          <OnboardingPortal />
        </Route>

        <Route exact path={constants.appPaths.appPathCreatorDemoPatient}>
          <EmpirePatientPortal />
        </Route>

        <Route render={() => <Redirect to={constants.appPaths.appPathCreator} />} />
      </Switch>
    );
  }
};

export default getEmpireOrganizationPortal;
